module.exports = __webpack_public_path__ + "assets/img/3_1137_big.11151ee9.jpg";